import React, { useRef } from 'react';

import useEventTracking from '@hooks/useEventTracking';
import useScrollerPosition from '@hooks/useScrollerPosition';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { NAV_OPTIONS, NavOption } from '../types';
import { NavButton } from './NavButton';

const SideNav = () => {
  const navRef = useRef<HTMLDivElement>(null);
  const scrollerRef = useRef<HTMLDivElement>(null);
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.SideNav,
  });

  const { activeSection, scrollerPosition, scrollToSection } = useScrollerPosition({
    navRef,
    scrollerRef,
  });

  const handleNavClick = (section: NavOption) => {
    scrollToSection(section);
    trackEvent(
      click({
        clickTarget: ClickTarget.NavLink,
        clickText: section,
      })
    );
  };

  return (
    <nav
      ref={navRef}
      className="sticky top-88 border-0 border-l-[5px] border-solid border-grayscale-beige"
    >
      <div
        ref={scrollerRef}
        className="absolute -left-[5px] top-0 h-24 w-[5px] -translate-x-[5px] bg-primary-magenta transition-transform"
        style={{ transform: `translateY(${scrollerPosition}px)` }}
      />
      <div className="flex flex-col gap-24">
        {NAV_OPTIONS.map((navItem) => (
          <NavButton
            key={navItem.id}
            {...navItem}
            isActive={navItem.id === activeSection}
            onClick={handleNavClick}
          />
        ))}
      </div>
    </nav>
  );
};

export default SideNav;
